import { configureStore } from '@reduxjs/toolkit';
import formReducer from './formSlice';
import individualReducer from './individualSlice';
import authReducer from './authSlice';

export const store = configureStore({
  reducer: {
    form: formReducer,
    individual: individualReducer,
    auth: authReducer,
  },
});
